import { AgentLogStatus } from "app/dashboard/model/dashboard.model";
import { useLocation, useSearchParams } from "react-router-dom";
import { RobotExecutionsRequest } from "../models/robot-executions.model";
import { useMemo } from "react";

export interface FilterActions {
    setStatus: (value: AgentLogStatus | undefined) => void
    setErrorReason: (value: boolean | undefined) => void;
    setDepartmentId: (value: number | undefined) => void;
    setMachineId: (value: number | undefined) => void;
    setStepId: (value: number | undefined) => void;
    setFilter: (filter: RobotExecutionsRequest) => void;
};

export const useStepExecutionFilterParams = () => {
    const [search, setSearch] = useSearchParams();

    const setFilter = (filter: RobotExecutionsRequest) => {
        const query = new URLSearchParams();
        if (filter.status !== undefined)
            query.set('status', filter.status.toString());
        if (filter.errorReason !== undefined)
            query.set('errorReason', filter.errorReason.toString())
        if (filter.departmentId !== undefined)
            query.set('departmentId', filter.departmentId.toString());
        if (filter.machineId !== undefined)
            query.set('machineId', filter.machineId.toString());
        if (filter.stepId !== undefined)
            query.set('stepId', filter.stepId.toString());
        setSearch(query);
    };

    const setStatus = (status: AgentLogStatus | undefined = undefined) => setSearch({ ...search, status: status?.toString() });

    const setErrorReason = (errorReason: boolean | undefined = undefined) => {
        if (errorReason === undefined) {
            setSearch({ ...search, errorReason: undefined });
            return;
        }
        setSearch({ ...search, errorReason: errorReason.toString() });
    };

    const setDepartmentId = (departmentId: number | undefined = undefined) => setSearch({ ...search, departmentId: departmentId?.toString() });

    const setMachineId = (machineId: number | undefined = undefined) => setSearch({ ...search, machineId: machineId?.toString() });

    const setStepId = (stepId: number | undefined = undefined) => setSearch({ ...search, stepId: stepId?.toString() });

    const memo = useMemo(() => {
        const statusParam = search.get('status');
        const status = statusParam ? +statusParam as AgentLogStatus : undefined;

        const errorReasonParam = search.get('errorReason');
        const errorReason = errorReasonParam ? errorReasonParam === 'true' : undefined;

        const departmentIdParam = search.get('departmentId');
        const departmentId = departmentIdParam ? +departmentIdParam : undefined;

        const machineIdParam = search.get('machineId');
        const machineId = machineIdParam ? +machineIdParam : undefined;

        const stepIdParam = search.get('stepId');
        const stepId = stepIdParam ? +stepIdParam : undefined;

        const query: RobotExecutionsRequest = {
            status,
            errorReason,
            departmentId,
            machineId,
            stepId
        }
        return query;
    }, [search]);
    const actions: FilterActions = { setStatus, setErrorReason, setDepartmentId, setMachineId, setStepId, setFilter };
    return [memo as RobotExecutionsRequest, actions] as const;
};
